import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  padding-inline: 20px;
  ${theme.breakpoints.up("tablet")} {
    padding-inline: 40px;
  }
`;
